import { c as _c } from "react/compiler-runtime";
import type { Option } from '@newfront-insurance/core-ui';
import { AdvancedSelectInput } from '@newfront-insurance/core-ui';
import type { PolicyType } from '@newfront-insurance/coverage-api';
import type { JSX } from 'react';
import { useDefinitionsHelpers } from '../../hooks/definitions';
export interface Props {
  onChange: (value: PolicyType) => unknown;
  placeholder?: string;
  value?: PolicyType;
  /** Setting it to true will allow the user to clear the selection with an X that shows up at the far right */
  isClearable?: boolean;
}
export function PolicyTypeSelectInput(t0) {
  const $ = _c(13);
  const {
    placeholder,
    value,
    onChange,
    isClearable
  } = t0;
  const {
    policyTypes,
    renderPolicyType
  } = useDefinitionsHelpers();
  let t1;
  if ($[0] !== policyTypes || $[1] !== renderPolicyType) {
    let t2;
    if ($[3] !== renderPolicyType) {
      t2 = policyType => ({
        label: renderPolicyType(policyType),
        value: policyType
      });
      $[3] = renderPolicyType;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = policyTypes.map(t2);
    $[0] = policyTypes;
    $[1] = renderPolicyType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const options = t1;
  let t2;
  if ($[5] !== onChange) {
    t2 = newValue => onChange(newValue as PolicyType);
    $[5] = onChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isClearable || $[8] !== options || $[9] !== placeholder || $[10] !== t2 || $[11] !== value) {
    t3 = <AdvancedSelectInput isClearable={isClearable} options={options} placeholder={placeholder} value={value} onChange={t2} />;
    $[7] = isClearable;
    $[8] = options;
    $[9] = placeholder;
    $[10] = t2;
    $[11] = value;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}